import { render, staticRenderFns } from "./RealtimeCompleted.vue?vue&type=template&id=7816dfe3&"
import script from "./RealtimeCompleted.vue?vue&type=script&lang=js&"
export * from "./RealtimeCompleted.vue?vue&type=script&lang=js&"
import style0 from "./RealtimeCompleted.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports